import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../../components/displaycard';

import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';

const policies = [
    {
        title: 'Zeek Scripts',
        description: 'Modify Zeek script policies and settings',
        img: '/images/zeek-scripts.png',
        route: '/policies/zeek/scripts',
        perm: {
            ZeekScriptsPolicy: [...Permissions.Policies.Zeek.ZeekScriptsPolicy],
            ZeekScripts: [...Permissions.Policies.Zeek.ZeekScripts],
        },
    },
    {
        title: 'Threat Intelligence',
        description: "Manage threat intelligence feeds for use with Zeek's intel framework",
        img: '/images/zeek-bt.png',
        route: '/policies/zeek/zeek_indicators',
        perm: {
            ThreatIntelPolicy: [...Permissions.Policies.Zeek.ThreatIntelPolicy],
            ThreatIntelIndicators: [...Permissions.Policies.Zeek.ThreatIntelIndicators],
        },
    }
];

const PolicyZeek = (props) => {
    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {policies.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard aria-label={p} {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default PolicyZeek;
